import Flash from "@shared/services/flashv2";

const PREVIEW_ROLES = ["supplier", "sales_rep"]

const SUPPLIER_PAGES = [/layout.home/, /layout.product_listing/, /layout.product_detail/, /layout.sponsored_content/, /layout.distributors/,
/^\/$/, /^\/\?$/, /^\/product_listing/, /^\/products\//, /^\/distributors$/, /^\/sc\/:slug$/, /^\/index/]
const SALES_REP_PAGES = [/layout.home/, /layout.product_listing/, /layout.product_detail/, /layout.sponsored_content/,
  /layout.cart/, /layout.storefront/, /layout.storefront_or_product_lines/, /layout.distributors/,
  /^\/$/, /^\/\?$/, /^\/product_listing/, /^\/products\//, /^\/cart$/, /^\/storefront/, /^\/distributors$/, /^\/sc\/:slug$/,
  /^\/index/]

export function showPreviewForbiddenFlash(flashType: string = 'now') {
  Flash[flashType]({
    type: 'info',
    message: 'Not accessible in preview mode.'
  });
};

export const restrictRepAccess = () => {
  if (window['$rootScope']?.user?.role === "sales_rep") {
    showPreviewForbiddenFlash();
    return true;
  }
  return false;
};

export const restrictPreviewAccess = () => {
  if (PREVIEW_ROLES.includes(window['$rootScope'].user.role)) {
    showPreviewForbiddenFlash();
    return true;
  }
  return false;
};

export const isStateAllowedForRole = (currentRole, toStateName) => {
  const allowedStatesPerRole = {
    supplier: SUPPLIER_PAGES,
    sales_rep: SALES_REP_PAGES
  }
  return allowedStatesPerRole[currentRole] ? allowedStatesPerRole[currentRole].filter(regex => toStateName.match(regex)).length > 0 : true;
}

export const isRestrictedRole = (rolesList) => {
  if (window["$rootScope"].user) {
    return rolesList.includes(window["$rootScope"].user.role)
  }
  return false;
}
